export const LOCALES = {
  ITALIAN: "it-it",
  ENGLISH: "en-us",
};
